import {isNil, noop} from 'lodash';

import {LABEL_COMING_SOON} from '/enum/label.enum';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';
import {showComingSoonToast} from '/util/toast.util';

/**
 * Generates a callback to be called when metric item is pressed
 *
 * @param {object} params - Parameters
 * @param {object} params.listItem - the item that was clicked
 * @param {function} params.onItemPress - a callback to call on press
 * @param {boolean} params.readonly - Whether the item is read only
 * @param {string} params.recordsName - The name of the report
 * @param {string} params.reportType - The type of report
 * @param {Number|string} params.value - The value to be displayed in the item
 *
 * @returns {function} - Callback - A function to be called when tab is pressed
 */
export function generateOnPress({
  listItem,
  onItemPress,
  readonly,
  recordsName,
  reportType,
  value,
}: any) {
  // TODO: get rid of this code once all pre-computed metrics are integrated
  if (value === LABEL_COMING_SOON || readonly || value === 0 || value === '0') {
    return noop;
  }
  return () => {
    if (!isNil(recordsName)) {
      onItemPress(listItem);
      getAnalyticsUtilDefaultInstance().trackReportMetricClick({
        recordsName,
      });
    } else {
      showComingSoonToast(`${reportType} Report`);
    }
  };
}
